import useStyles from 'isomorphic-style-loader/useStyles';
import type { PropsWithChildren } from 'react';
import { Icon, Label } from 'semantic-ui-react';

import Link from '@components/link';
import { useRouteContext } from '@components/router';
import type { PolicyBundle } from '@features/policy/policies.models';

import { useSideNavContext } from './side-nav-context';
import s from './side-nav-popup.scss';

export const ReturnLink = ({
  path,
  label,
}: {
  path: string;
  label: string;
}) => (
  <Link to={path}>
    <Icon name="tag" color="teal" />
    <span>
      Return to&nbsp;
      <strong>{label}</strong>
    </span>
  </Link>
);

export const PolicyPopupContent = ({
  data,
}: {
  data: PolicyBundle[] | null;
}) => {
  useStyles(s);

  const { params } = useRouteContext();

  if (!data) return null;

  const policyLinks = data.map(pItem => (
    <Link
      key={pItem.policy_id}
      className={s.policyLink}
      to={`/policy/${pItem.policy_id}`}
      style={
        // TODO: We don't currently support showing a popup for the active item so this is redundant code
        params && params.policyId === pItem.policy_id
          ? {
              color: 'rgba(0,0,0,.87)',
              cursor: 'default',
              fontWeight: 700,
            }
          : undefined
      }
    >
      <div>{pItem.name}</div>
      {pItem.active ? (
        <Label
          style={{
            marginLeft: '0.5rem',
            minWidth: 'max-content',
          }}
          color="green"
          size="mini"
        >
          Active
        </Label>
      ) : null}
    </Link>
  ));

  return <div className={s.policyContent}>{policyLinks}</div>;
};

export const SideNavPopupContent = ({
  children,
  label,
}: PropsWithChildren<{ label: string }>) => {
  useStyles(s);

  const { isExpanded } = useSideNavContext();

  return (
    <div className={s.sideNavItemPopupContent}>
      {!isExpanded && (
        <>
          <strong>{label}</strong>
          {children && (
            <span>
              <Icon color="teal" name="triangle right" fitted />
            </span>
          )}
        </>
      )}
      {children && <div>{children}</div>}
    </div>
  );
};
